import cn from './zh'
import en from './en'
import { useLanguage } from '../composables/useLanguage'
export type LangPack = Record<string, string>
export type LangKey = keyof typeof cn // 基础 key

const langPacks: Record<string, LangPack> = {
  cn,
  en
}
// 3. 注册新语言包的方法（供业务包调用）
export function registerLangPack(langCode: string, pack: LangPack) {
  langPacks[langCode] = pack
}

export const lang = (key: string): string => {
  try {
    // 使用useLanguage中的语言状态
    const { language } = useLanguage()
    const langCode = language.value || 'cn'

    const pack = langPacks[langCode]
    if (!pack) {
      console.warn(`Missing language pack for: ${langCode}`)
      return key
    }

    return pack[key] || key
  } catch (error) {
    // 如果useLanguage未初始化，使用默认语言
    console.warn('useLanguage not initialized, using default language:', error)
    const pack = langPacks['cn']
    return pack[key] || key
  }
}
